// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"U0-z","categoryName":"V0-z","categoryImage":"W0-z","categoryContent":"X0-z","bottomAligned":"Y0-z"};